import { render, staticRenderFns } from "./DmDriverLabelForm.vue?vue&type=template&id=5900ba84&scoped=true"
import script from "./DmDriverLabelForm.vue?vue&type=script&lang=js"
export * from "./DmDriverLabelForm.vue?vue&type=script&lang=js"
import style0 from "./DmDriverLabelForm.vue?vue&type=style&index=0&id=5900ba84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5900ba84",
  null
  
)

export default component.exports